{
  "sparkjs_version_card": {
    "latest_label": "Always use latest"
  },
  "graphics": {
    "srp": "SRP: {price}",
    "tiered_pricing": {
      "from": "From {price}",
      "save": "Save {percent}"
    },
    "pack_sizing": {
      "packs_of": "Available in packs of {size}"
    },
    "registration_form": {
      "title": "Apply for B2B access"
    },
    "b2b_only_content": {
      "title": "B2B Information"
    },
    "multi_add": {
      "title": "Product collection",
      "quantity": "{quantity} x"
    },
    "pre_order": {
      "label": "Pre-order this"
    },
    "min_quantities": {
      "title": "Minimum order of {quantity} units"
    },
    "b2b_shipping": {
      "title": "B2B Shipping Method",
      "standard": "Standard",
      "express": "Express",
      "weekend": "Weekend"
    }
  }
}
